import $ from 'jquery';
import { parseQueryParams } from './shared/utils';
require('./page');

// @phone: moving homepage feature preview images to text block 
(function () {
  // / media query to check
  var phoneMQ = '(max-width: 800px) and (orientation: portrait)';
  // var phoneMQ = '(max-width: 1100px)';
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  // matched or not
  if (isPhoneView) {
    var pas = $('#pricing-plans .pricing-actions-wrap')
    pas.each(function (i, pa) {
      // console.log('pa', pa)
      if (pa) {
        var ptwrap = pa.parentNode.parentNode
        if (ptwrap) {
          ptwrap.insertBefore(pa, ptwrap.querySelector('.pricing-table-head'))
        }
      }
    })
  }
}());

// @phone: pricing tabs func 
(function () {
  // / media query to check
  var phoneMQ = '(max-width: 800px) and (orientation: portrait)';
  // var phoneMQ = '(max-width: 1100px)';
  // matched or not
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  if (isPhoneView) {
    $("#pricing-cdn .subtext").text('viewers');

    var onPricingTabActive = function (el) {
      $('.plan-id-wrap').removeClass('tab-active')
      el = $(el)
      el.addClass('tab-active')
      var tabIndex = el.data().productColId + 1

      $('#table-tab-css').remove()
      var css = document.createElement('style')
      css.id = 'table-tab-css'
      css.innerHTML = `.feat-row td:nth-of-type(${tabIndex}) {display: table-cell !important;}`
      document.body.appendChild(css)
    }

    var planHeads = $('.plan-id-wrap')
    planHeads.on('click', function () { onPricingTabActive(this) });
    onPricingTabActive(planHeads[0])

    var onPlanTypeChange = function () {
      var activeEntity = $(this).data('entity');
      var showCompanyPlans = activeEntity === 'company';
      if (this.tagName === 'INPUT') {
        showCompanyPlans = this.checked === true;
      }

      if (showCompanyPlans) {
        onPricingTabActive(planHeads[4])
      } else {
        onPricingTabActive(planHeads[0])
      }
    }

    $('.pricing-entity-switch .period-control').on('click', onPlanTypeChange)
    $('.pricing-switch-checkbox').on('change', onPlanTypeChange);

    // preselect 6th cdn pricing tab
    $('#pricing-cdn .plan-id-wrap[data-product-col-id=1]').click()
  }
}());

// live delivert type switch
(function () {
  $('.live-cat-tabs .live-cat-tab').on('click', function () {
    var el = $(this)
    el.addClass('selected')
    el.siblings().removeClass('selected')
  })
})();

// init plans list type tabs
(function () {
  var tab_selector = '.live-cat-tabs[data-plans-list-selection] .live-cat-tab'
  $(tab_selector).on('click', function () {
    // var el = $(this)
    // el.addClass('selected')
    // el.siblings().removeClass('selected')

    var targetPlansList = $(this).data().targetPlansList;
    $(tab_selector).each(function (i, node) {
      var el_ = $(this);
      // console.log('each-node', el_.data())
      if (el_.data().targetPlansList === targetPlansList) {
        el_.addClass('selected')
      } else {
        el_.removeClass('selected')
      }
    })

    $('[data-plans-list-type]').each((function (i, node) {
      node = $(node);
      if (node.data().plansListType === targetPlansList) {
        node.show()
      } else {
        node.hide()
      }
    }));
  });
})();

// force enable annual billing on pageload
(function () {
  // $('.pricing-switch-wrap [data-period="y"]').trigger('click')
  $('.pricing-switch-wrap [data-period="y"]').get(0).click()
})();

// force enable annual billing on pageload
(function () {
  var params = parseQueryParams();
  if (params.plans_category === 'livestreaming') {
    $('.live-cat-tabs[data-plans-list-selection] .live-cat-tab').get(1).click()
  }
})();